import styled from "styled-components";
import backImage from "../../../../assets/images/icons/back-logo.svg";
import topImage from "../../../../assets/images/icons/back-logo.svg";
import colors from "assets/scss/colors.scss";

const MotorAccordWrapper = styled.div`

  background-image: url(${topImage}), url(${backImage}) !important;
  background-repeat: no-repeat !important;
  background-position: top right, bottom left !important;

  .p-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
    border-radius: 12px;
    background: rgb(255, 255, 255) !important;
    background-image: url(${topImage}), url(${backImage}) !important;
    background-repeat: no-repeat !important;
    background-position: top right, bottom left !important;
    }
  }
  .set-accord {
  padding: 0;
  margin-bottom: 24px;
  text-align: initial;
  }
  .policy-cover .p-accordion .p-accordion-header .p-accordion-header-link {
    border-radius: 12px;
    background: rgb(255, 255, 255) !important;
  display: block !important;
  padding: 0 !important;
  }
  .p-accordion-toggle-icon.pi {
  display: none;
  }
  .welcome-text {
  b{
  // font-family: tawuniya;
  font-size: 20px;
  font-weight: 800;
  line-height: 24px;
  letter-spacing: -0.01em;
  }
  // font-family: tawuniya;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.01em;
  }
  .header-Text {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 140px;
  }
  .head-icon {
  width: 8%;
  }
  .inner-content{

  }
  .Icon-Div{
  a{
  padding: 0 10px;
  }
  }
  .p-accordion-header.p-highlight{
  .Icon-Div{
  a{
    color: #6B47F5;
  }
  }
  }
  .up-acc {  color: ${colors["bright-purple"]}}
  .down-acc 
  color: #6B47F5 !important;
  }

  .p-accordion .p-accordion-content {
  padding: 24px !important;
  border-radius: 0px 0px 12px 12px !important;
  }
  .p-accordion
  .p-accordion-header:not(.p-disabled).p-highlight
  .p-accordion-header-link {
    border-radius: 12px;
  border-radius: 12px 12px 0px 0px !important;
  background: rgb(255, 255, 255) !important;
  }
  .header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  }
  .p-accordion .p-accordion-header .p-accordion-header-link {
    border-radius: 12px;
    background: rgb(255, 255, 255) !important;
  border-radius: 12px !important;
  display: block !important;
  padding: 20px !important;
  background-image: url(${topImage})!important;
    background-position: right bottom, left top !important;
  background-repeat: no-repeat, no-repeat !important;
  background-size: auto, auto !important;
  }
  @media only screen and (max-width: 576px) {
    background-image: none !important;
    .welcome-text {
      padding: 0px 28px;
    }
}
`;

export default MotorAccordWrapper;
